export { default } from './page-print';
